module.exports = __webpack_public_path__ + "img/maskan.bf3ada51.png";